import { createFileRoute } from '@tanstack/react-router';
import { InvoiceFormPage } from '@/pages/Invoice/InvoiceFormPage';

function NewCreditMemoRoute() {
  return <InvoiceFormPage documentType="credit_memo" />;
}

export const Route = createFileRoute('/_admin/invoice/credit-memo/new')({
  component: NewCreditMemoRoute,
});
